import React, { useEffect, useState } from 'react'
import styles from './AllMatchesList.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { homeData } from '../../features/home/homeSlice';
import { Link } from 'react-router-dom';
import demo2  from '../../assets/images/download (1).jpeg'
import vsImage from "../../assets/images/vs.png";
import Timer from '../Timer/Timer';
import LiveScore from '../LiveScore/LiveScore';
import Skeleton from '../Skeleton/Skeleton';

const AllMatchesList = () => {

  const dispatch = useDispatch();
  const [firstRender, setfirstRender] = useState(true);
  const data = useSelector((state) => state.home.data);
  const pending = useSelector((state) => state.home.pending);
  const error = useSelector((state) => state.home.error);
  const finalData = data.data;

  useEffect(() => {
    
      dispatch(homeData());
    
  }, []);
 
  useEffect(() => {
    if (firstRender && !pending) {
      setfirstRender(false);
    }
  }, [pending]);

  if(data.msg === "No Data Found." ){
    return <div>No Match at this moment..</div>;
  }


  if (pending && firstRender ) {
    return <div className={styles.loader}>
    <Skeleton type="UpcomingAndRecent" />
  </div>;
  }
  return (
    <div  className={styles.allMatchListWrapper}>
       {finalData &&
            finalData.map((item, index) => (
              <Link to={`/live-score/match/${item.match_id}/${item.match_status}`}>
              <div className={styles.slide} key={index}>
                {console.log(item.match_status)}
                <div className={styles.matchData}>
                  <div className={styles.firstContainer}>
                    <div className={styles.matchInfo}>
                      <p className={styles.teamsName}>
                        {item.team_a} vs {item.team_b}{" "}
                      </p>
                      <p className={styles.seriesName}>{item.series}</p>
                    </div>

                    <p className={styles.matchStatus}>{item.match_status}</p>
                  </div>
                  <div className={styles.secondContainer}>
                    {(() => {
                      switch (item.match_status.toLowerCase()) {
                        case "live":
                          return <p className={styles.toss}>{item.toss ? item.toss : ""}</p>;
                        case "finished":
                          return <p className={styles.toss}>{item.result ? item.result : ""}</p>;
                          case "upcoming":
                            return <div className={styles.startTime}>
                            <p>STARTS IN</p>
                            <Timer timeValue={item.date_time} key={index} />
                          </div>;  
                        default:
                          return null;
                      }
                    })()}
                  </div>
                  <div className={styles.thirdContainer}>
                    <div className={styles.teamDetails}>
                      <div className={styles.teamLogo}>
                        <img src={demo2} alt={item.team_a_short} />
                      </div>
                      <div className={styles.teamShortName}>
                        {item.team_a_short}
                      </div>
                      <div className={styles.teamScore}>
                      <LiveScore match_id = {item.match_id} team = {"team_A"}/>
                        {/* <p
                          className={
                            item.match_status.toLowerCase() === "live" ||
                            item.match_status.toLowerCase() === "finished"
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {item.team_a_scores_over.length === 0
                            ? "-"
                            : item.team_a_scores_over[0].score}
                        </p>
                        <p
                          className={
                            item.match_status.toLowerCase() === "live" ||
                            item.match_status.toLowerCase() === "finished"
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {item.team_a_scores_over.length === 0
                            ? "yet to bat"
                            : item.team_a_scores_over[0].over + " over"}
                        </p> */}
                      </div>
                    </div>
                    <div className={styles.vsImage}>
                      <img src={vsImage} alt="" />
                    </div>
                    <div className={styles.teamDetails}>
                      <div className={styles.teamLogo}>
                        <img src={demo2} alt={item.team_b_short} />
                      </div>
                      <div className={styles.teamShortName}>
                        {item.team_b_short}
                      </div>
                      <div className={styles.teamScore}>

                      <LiveScore match_id = {item.match_id} team = {"team_B"}/>
                        {/* <p
                          className={
                            item.match_status.toLowerCase() === "live" ||
                            item.match_status.toLowerCase() === "finished"
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {item.team_b_scores_over.length === 0
                            ? "-"
                            : item.team_b_scores_over[0].score}
                        </p>
                        <p
                          className={
                            item.match_status.toLowerCase() === "live" ||
                            item.match_status.toLowerCase() === "finished"
                              ? styles.active
                              : styles.inactive
                          }
                        >
                          {item.team_b_scores_over.length === 0
                            ? "yet to bat"
                            : item.team_b_scores_over[0].over + " over"}
                        </p> */}
                      </div>
                    </div>
                  </div>
                  <div className={styles.fourthContainer}>
                    <div className={styles.rates}>
                      <p className={styles.ratesfirstTeam}>{item.min_rate}</p>
                      <p className={styles.ratesSecondTeam}>{item.max_rate}</p>
                    </div>
                    
                  </div>
                </div>
                <div className={styles.pointsTable}>
                      <p>View Points Table</p>
                    </div>
              </div>
                </Link>
            ))}
      
    </div>
  )
}

export default AllMatchesList
